export default "__VITE_ASSET__DChQPnac__"